import axios from 'axios'

export const getStatuses = client => axios
    .get(`statuses`, {params: {client}})
    .then(response => response.data);